import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Menu, Dropdown, Popconfirm, Tooltip } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, DownOutlined } from '@ant-design/icons';
import DealModal from 'pages/network/qualityServices/components/dealModal';
import { useSelector } from 'react-redux';

function AntTableActions(props) {
  const { row, handleDelete, id, name, cancel, showFlag, show, deleteFlag, toggle, params, myCommodityName, isVehicle = false, row2, attachDealLink, setIsOpen, setSelectedRowData, setClosePopup, setIsEdit, isRecordSaved, isDriver, isQualityServices, handleInwardOutwardChange, isNetworkTab, currentPath, isFromQS = false } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const userInfo = useSelector((state) => state.user);
  const personRoles = _.get(userInfo, 'profile.person_role') || "";
  const hasCTSuperuserRole = personRoles.some(obj => obj.role_code === "CT Superuser");
  const hasCToperationsrRole = personRoles.some(obj => obj.role_code === "CT Operations");

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const menu = (row) => {
    const handleMenuClick = (e) => {
      if (e.key === 'share') {
        showModal();
      }
    };

    const disabledTitle = "Reports generated through the FTK machine cannot be edited"; 
    return (
      <Menu>
        {!toggle ? (
          !show ? isVehicle ?
            <Menu.Item>
              {row.generated_via_enum === 1 ?
                <Tooltip title={disabledTitle} placement='left'>
                  <span style={{ cursor: "not-allowed", color: "grey", }}>
                    Edit
                  </span>
                </Tooltip> :
                <a
                  href='#'
                  onClick={() => {
                    row.setVehicleData(row);
                    row.setOpen(true);
                    row.setEdit(true);
                  }}>
                  Edit
                </a>
              }
            </Menu.Item> :
            setIsOpen ?
              <Menu.Item
              // onClick={() => (setSelectedRowData(row), setIsOpen(true), setIsEdit(true), setClosePopup(false))}
              >
                {row.generated_via_enum === 1 ?
                  <Tooltip title={disabledTitle} placement='left'>
                    <span style={{ cursor: "not-allowed", color: "grey", }}>
                      Edit
                    </span>
                  </Tooltip>
                  :
                  <a href='#' onClick={() => (setSelectedRowData(row), setIsOpen(true), setIsEdit(true), setClosePopup(false))}>
                    Edit
                  </a>
                }
              </Menu.Item> :
              <Menu.Item>
                {row.generated_via_enum === 1 ?
                  <Tooltip title={disabledTitle} placement='left'>
                    <span style={{ cursor: "not-allowed", color: "grey", }}>
                      Edit
                    </span>
                  </Tooltip>
                  :
                  <Link to={row.editPageLink}>
                    Edit
                  </Link>
                }
              </Menu.Item>
            :
            <>
              {!isFromQS && <>
                <Menu.Item>
                  <Link to={row}>Create {myCommodityName === 'requirements' ? 'Buy' : 'Sell'}</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={row2}>Create Auction</Link>
                </Menu.Item>
              </>}
              {attachDealLink ? <Menu.Item>
                <Link to={attachDealLink}>Link {myCommodityName === 'requirements' ? 'Buy' : 'Sell'} Deal</Link>
              </Menu.Item> : ''}
            </>
        ) : (
          <Menu.Item>
            {row.generated_via_enum === 1 ?
              <Tooltip title={disabledTitle} placement='left'>
                <span style={{ cursor: "not-allowed", color: "grey" }}>
                  Edit
                </span>
              </Tooltip>
              :
              <a href="#" onClick={(e) => row.showDetailsPopup(e, row)}>
                Edit
              </a>
            }
          </Menu.Item>
        )
        }
        {
          (row?.stock_in_out_type_enum !== 8 && row?.stock_in_out_type_enum !== 9) && <Popconfirm
            title={`Are you sure to delete?`}
            onConfirm={() => (params ? handleDelete(id, params) : handleDelete(id, isRecordSaved))}
            onCancel={cancel}
            okText="Yes"
            cancelText="No">
            {deleteFlag != false && (
              <Menu.Item danger>
                <span>Delete</span>
              </Menu.Item>
            )}
          </Popconfirm>
        }
        {
          (hasCTSuperuserRole || hasCToperationsrRole) && isQualityServices && (
            <Menu.Item onClick={handleMenuClick} key="share"> Share </Menu.Item>
          )
        }
        {/* Add the Move action for CT Superusers in network quality services */}
        {
          (hasCTSuperuserRole || hasCToperationsrRole) && isQualityServices && isNetworkTab && (
            <Menu.Item
              key="move"
              // icon={currentPath.includes('inward') ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}

              // Inward_Outward_Enum pass
              onClick={(e) => handleInwardOutwardChange(row?.quality_record_master_id)}
            >
              {currentPath.includes('inward') ? 'Move to Outward' : 'Move to Inward'}
            </Menu.Item>
          )
        }
      </Menu >
    );
  };
  return (
    <div>
      <Dropdown overlay={menu(row)} placement="bottomCenter">
        {showFlag ? (
          <a className="ant-dropdown-link d-flex justify-content-center" onClick={(e) => e.preventDefault()}>
            Actions <DownOutlined className="mt-10 ml-5" />
          </a>
        ) : (
          <div></div>
        )}
      </Dropdown>
      {isModalVisible &&
        <DealModal visible={isModalVisible} onCancel={handleCancel} row={row} DealId={id} role={"Network"} />}
    </div>
  );
}

export default AntTableActions;
